export default {
  maxValue (max) {
    return (rule, value, callback) => {
      if (value !== undefined && value !== null && value !== '' && !Number.isNaN(value * 1.0)) {
        if (value * 1.0 > max) {
          callback(new Error(`值不能大于${max}`))
        }
      }
      callback()
    }
  }
}
